// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","formModalHeader":"_2Z2N96ivuF6MD1mJ4Wwpen","formAlert":"_17XHsytccDAAu-NHD7zEsB"};